module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend-company"
  }, [_c('div', {
    staticClass: "recommend-title"
  }, [_vm._v("\n\t\t同行业企业推荐\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "company-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return [_c('div', {
      staticClass: "company-item"
    }, [_c('el-avatar', {
      attrs: {
        "shape": "square",
        "size": 45
      }
    }, [_vm._v(" " + _vm._s(item.company_name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "company-right"
    }, [_c('div', {
      staticClass: "company-title text-cut1 margin-bottom-4"
    }, [_vm._v(" " + _vm._s(item.company_name))]), _vm._v(" "), _c('div', {
      staticClass: "margin-bottom-4"
    }, [_c('el-tag', {
      staticClass: "bg-blueFF margin-right-8",
      attrs: {
        "effect": "dark",
        "size": "mini "
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.industry || '') + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "city_str"
    }, [_vm._v("#" + _vm._s(item.city_str || ''))])])])], 1)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c7c54f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recommend.vue
// module id = 1098
// module chunks = 1